<template>
  <v-container height="1000px">
    <h1>{{ item.semesterNumber }}</h1>
    <vc-calendar
      columns="4"
      is-expanded
      rows="3"
      from-date="2022-01-01"
      @dayclick="ShowDayEvents"
      :attributes="attributes"
      :theme-styles="themeStyles"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({
    semesters: null,
    themeStyles: {
      backgroundColor: "red",
      border: "1px solid #dadada",
    },
    attributes: [
      {
        key: "today",
        highlight: "red",
      },
      {
        highlight: "red",
        dates: [
          new Date(2022, 5, 4), // Jan 4th
          new Date(2022, 5, 10), // Jan 10th
          new Date(2022, 5, 15), // Jan 15th
        ],
      },
    ],
  }),
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this.semesters = [1, 2];
    console.log(this.item);
  },

  methods: {
    _isFound() {},
    ShowDayEvents(e) {
      var ddate = new Date(e.id);
      console.log(ddate);
      console.log(ddate.getMonth(), ddate.getTime());

      var xx = this.attributes[1].dates.find(
        (element) => element.getTime() == ddate.getTime()
      );
      if (xx) {
        var ii = this.attributes[1].dates.indexOf(xx);
        console.log(ii);
        this.attributes[1].dates.splice(ii, 1);
      } else {
        this.attributes[1].dates.push(new Date(e.id));
      }
    },
  },
};
</script>
